import React from 'react';
import styled from 'styled-components';

import Body1 from '@joinforma/ui/components/Body1';
import Headline1 from '@joinforma/ui/components/Headline1';
import { SCREEN_WIDTHS } from '@joinforma/ui/constants/breakpoints';

import BannerGraphic from 'assets/images/store-landing/banner.svg';
import Gradient from 'assets/images/store-landing/gradient.jpg';

import { STORE_LAYOUT_ELEMENTS } from 'constants/testSelectors';

import SearchBox from './SearchBox';

const Container = styled.div`
  background-image: url(${Gradient});
  background-size: cover;
  width: 100%;
`;

const CenteredContainer = styled.div`
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
`;

const MainContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  width: 100%;
  max-width: 520px;
  padding: 72px 20px;
`;

const Title = styled(Headline1)`
  color: ${({ theme }) => theme.colors.text.light};
  margin-bottom: 8px;
`;

const Subtitle = styled(Body1)`
  color: ${({ theme }) => theme.colors.text.light};
  margin-bottom: 36px;
`;

const GraphicContainer = styled.div`
  display: none;
  align-self: flex-end;
  overflow: hidden;

  @media (min-width: ${SCREEN_WIDTHS.MOBILE_LANDSCAPE}) {
    display: block;
  }
`;

const Graphic = styled.img.attrs({
  alt: 'Banner graphic',
  src: BannerGraphic,
})`
  width: 700px;
`;

const SearchBannerWithGraphic = ({
  query,
  setSearchQuery,
}: {
  query: string;
  setSearchQuery: (query: string) => void;
}) => (
  <Container data-testid={STORE_LAYOUT_ELEMENTS.SEARCH_WITH_GRAPHIC}>
    <CenteredContainer>
      <MainContainer>
        <Title>How will you spend your benefit funds today?</Title>
        <Subtitle>
          Explore a universe of choice in our flexible benefits store.
        </Subtitle>
        <SearchBox
          label="Search for an item and hit enter"
          query={query}
          setSearchQuery={setSearchQuery}
        />
      </MainContainer>
      <GraphicContainer>
        <Graphic />
      </GraphicContainer>
    </CenteredContainer>
  </Container>
);

export default SearchBannerWithGraphic;
